import axios from "axios";
import Config from "../utils/Config";

const ENVELOPE_KEYS = new Set([
  "status_code",
  "status",
  "data",
  "reason",
  "message",
  "success",
]);

class DashboardService {
  constructor() {
    this.pending = new Map();
  }

  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_tk")}`,
      },
    };
  }

  unwrap(body) {
    let current = body;
    for (let depth = 0; depth < 4; depth += 1) {
      if (!current || typeof current !== "object" || Array.isArray(current)) break;
      const keys = Object.keys(current);
      const isEnvelope =
        current.data &&
        typeof current.data === "object" &&
        (current.status_code != null || keys.every((key) => ENVELOPE_KEYS.has(key)));
      if (!isEnvelope) break;
      current = current.data;
    }
    return current && typeof current === "object" ? current : {};
  }

  async get(path, year) {
    const key = `${path}?year=${year}`;
    if (this.pending.has(key)) return this.pending.get(key);

    const request = axios
      .get(`${Config.apiUrl}${path}`, {
        ...this.getAuthHeaders(),
        params: { year },
      })
      .then((response) => ({ status: true, data: this.unwrap(response.data) }))
      .catch((error) => ({
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Failed to load dashboard data",
        data: null,
      }))
      .finally(() => {
        this.pending.delete(key);
      });

    this.pending.set(key, request);
    return request;
  }

  getSalesRevenue(year) {
    return this.get("/provider/analytics/sales-revenue", year);
  }

  getProductPerformance(year) {
    return this.get("/provider/analytics/product-performance", year);
  }

  getClaims(year) {
    return this.get("/provider/analytics/claims", year);
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
